var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2049 3.43459C1.2049 2.81755 1.32641 2.34832 1.51397 2.01234L19.5454 20.0438L1.52132 38.0679C1.33005 37.7256 1.2049 37.2568 1.2049 36.6437V3.43459Z",
    fill: "#111111",
    stroke: "#DEDEDE",
    strokeWidth: 1.06605
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4959 21.744L26.3676 25.7978L20.6045 20.0348L26.3617 14.2776L33.4959 18.3349C33.4959 18.3349 33.496 18.3349 33.496 18.3349C34.4514 18.8785 34.8033 19.5157 34.8033 20.0394C34.8033 20.5631 34.4514 21.2004 33.496 21.7439C33.496 21.7439 33.4959 21.744 33.4959 21.744Z",
    fill: "#111111",
    stroke: "#DEDEDE",
    strokeWidth: 1.06605
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16883 38.6927L20.0679 20.7936L25.5409 26.2666L4.21023 38.3855C4.21006 38.3856 4.20989 38.3857 4.20972 38.3858C3.34453 38.8747 2.65548 38.908 2.16883 38.6927Z",
    fill: "#111111",
    stroke: "#DEDEDE",
    strokeWidth: 1.06605
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21023 1.69335L25.5409 13.8122L20.0679 19.2853L2.16619 1.38358C2.65114 1.16647 3.33987 1.20155 4.20973 1.69307C4.20989 1.69316 4.21006 1.69326 4.21023 1.69335Z",
    fill: "#111111",
    stroke: "#DEDEDE",
    strokeWidth: 1.06605
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.0d2ae62435f3bc3c834ef8b5fc43e85b.svg";
export { ForwardRef as ReactComponent };